import type {
  GetDocumentAttachmentsRequestType,
  GetDocumentAttachmentsResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const getDocumentAttachments = async (
  documentId: GetDocumentAttachmentsRequestType['documentId'],
) => {
  const url = `/api/v2/documents/${documentId}/attachments`;
  const response =
    await apiAuthClient.get<GetDocumentAttachmentsResponseType>(url);

  return response.data.data;
};
